import script from "./ReviewsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewsSection.vue?vue&type=script&setup=true&lang=ts"

import "./ReviewsSection.vue?vue&type=style&index=0&id=77c68256&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77c68256"]])

export default __exports__